<section class="verwaltung-container">
  <header class="verwaltung-header">
    <div>
      <h2>Skills & Kategorien</h2>
      <p>Globale Einträge gelten für alle Teams. Teams können globale Einträge übernehmen oder eigene anlegen.</p>
    </div>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="scope-select" *ngIf="scopes.length > 1">
      <mat-label>Verwaltungsbereich</mat-label>
      <mat-select [value]="selected?.teamId ?? null" (selectionChange)="selectScope($event.value)">
        <mat-option *ngFor="let scope of scopes" [value]="scope.teamId">
          <mat-icon>{{ scope.teamId === null ? 'public' : 'groups' }}</mat-icon>
          {{ scope.teamId === null ? 'Global' : 'Team ' + scope.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <span class="scope-single" *ngIf="scopes.length === 1 && selected">
      <mat-icon>{{ selected.teamId === null ? 'public' : 'groups' }}</mat-icon>
      {{ selected.teamId === null ? 'Global' : 'Team ' + selected.label }}
    </span>
  </header>

  <div class="loading" *ngIf="loading"><mat-spinner diameter="22"></mat-spinner> Berechtigungen werden geladen …</div>
  <p class="error-message" *ngIf="error" role="alert">{{ error }}</p>
  <p class="empty-scope" *ngIf="!loading && !error && scopes.length === 0">
    Du leitest derzeit kein aktives Team und darfst daher keine Skills oder Kategorien verwalten.
  </p>

  <mat-tab-group *ngIf="selected" animationDuration="150ms" mat-stretch-tabs="false" class="catalog-tabs">
    <mat-tab label="Skills">
      <ng-template matTabContent>
        <app-resource-catalog [kind]="'skills'" [teamId]="selected.teamId" [teamName]="selected.label"
          [canEdit]="selected.canEdit"></app-resource-catalog>
      </ng-template>
    </mat-tab>
    <mat-tab label="Kategorien">
      <ng-template matTabContent>
        <app-resource-catalog [kind]="'categories'" [teamId]="selected.teamId" [teamName]="selected.label"
          [canEdit]="selected.canEdit"></app-resource-catalog>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</section>
